import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankerService {
  private baseUrl = `${environment.baseUrlApi}/bankers`;

  constructor(private http: HttpClient) {}

  // ✅ Ajouter un banquier
  addBanker(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, data);
  }

  // ✅ Récupérer tous les banquiers avec pagination + recherche
  getPaginatedBankers(perPage: number, page: number, search: string): Observable<any> {
    const params = new HttpParams()
      .set('perPage', perPage.toString())
      .set('page', page.toString())
      .set('search', search);
    return this.http.get(this.baseUrl, { params });
  }

  // ✅ Récupérer un banquier par ID
  getBankerById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  // ✅ Mettre à jour un banquier
  updateBanker(id: number, data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, data);
  }

  // ✅ Supprimer un banquier
  deleteBanker(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}
